<div class="keyboard">

  <div class="container">

    <div class="visor">{{ pinView }}</div>

    <ion-grid>
      <ion-row>
        <ion-col size="4">
          <ion-button class="key" shape="round" (click)="pressNumber(1)">1</ion-button>
        </ion-col>

        <ion-col size="4">
          <ion-button class="key" shape="round" (click)="pressNumber(2)">2</ion-button>
        </ion-col>

        <ion-col size="4">
          <ion-button class="key" shape="round" (click)="pressNumber(3)">3</ion-button>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="4">
          <ion-button class="key" shape="round" (click)="pressNumber(4)">4</ion-button>
        </ion-col>

        <ion-col size="4">
          <ion-button class="key" shape="round" (click)="pressNumber(5)">5</ion-button>
        </ion-col>

        <ion-col size="4">
          <ion-button class="key" shape="round" (click)="pressNumber(6)">6</ion-button>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="4">
          <ion-button class="key" shape="round" (click)="pressNumber(7)">7</ion-button>
        </ion-col>

        <ion-col size="4">
          <ion-button class="key" shape="round" (click)="pressNumber(8)">8</ion-button>
        </ion-col>

        <ion-col size="4">
          <ion-button class="key" shape="round" (click)="pressNumber(9)">9</ion-button>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="4">
          <ion-button
            class="key exit"
            shape="round"
            (click)="exit()"
          >
            <ion-icon slot="icon-only" name="arrow-back-outline" color="light"></ion-icon>
          </ion-button>
        </ion-col>

        <ion-col size="4">
          <ion-button class="key" shape="round" (click)="pressNumber(0)">0</ion-button>
        </ion-col>

        <ion-col size="4">
          <ion-button
            class="key delete"
            shape="round"
            (click)="deletePin()"
          >
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
          </ion-button>

        </ion-col>
      </ion-row>

    </ion-grid>

  </div>

</div>
